/**
 * Extracts the video id from a YouTube URL (watch, youtu.be, embed, ...). @vue-youtube/core provides no
 * equivalent helper, hence this.
 */
export const getYoutubeIdFromUrl = (url: string | undefined): string | undefined => {
  const match = url?.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)
  return match && match[2] ? match[2] : undefined
}
